import { MetaInfo } from 'vue-meta';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Transitions } from './types';

@Component({
  metaInfo(): MetaInfo {
    const { fullscreen } = this as ComponentModalDefault;
    if (!fullscreen) return {};
    return {
      bodyAttrs: {
        'data-modal-noscroll': '',
      },
    };
  }
})
export default class ComponentModalDefault extends Vue {
  // Props
  @Prop({ type: Boolean, default: false })
  center: boolean;

  @Prop({ type: Boolean, default: true })
  closeButton: boolean;

  @Prop({ type: Boolean, default: true })
  closeEsc: boolean;

  @Prop({ type: Boolean, default: false })
  fullscreen: boolean;

  @Prop({ type: String, default: '' })
  footer: string;

  @Prop({ type: Boolean, default: false })
  grey: boolean;

  @Prop({ type: String, default: '' })
  header: string;

  @Prop({ type: String, default: '' })
  text: string;

  @Prop({
    type: String,
    default: Transitions.FADE,
    validator: value => Object.values(Transitions).indexOf(value) !== -1,
  })
  transition: Transitions;

  @Prop({ type: Boolean, default: false })
  visible: boolean;

  // Computed
  get classes() {
    return {
      'modal-default__container_background': this.grey,
      'modal-default__container_center': this.center,
      'modal-default__container_fullscreen': this.fullscreen,
    };
  }

  get transitionName() {
    return `modal-default_transition-${this.transition}`;
  }

  // Hooks
  mounted() {
    this.$on('hide', this.close)
  }

  beforeDestroy() {
    this.$off('hide', this.close)
  }

  // Methods
  close(event: any = null) {
    this.$emit('close', event);
  }

  onClick(event: any) {
    this.close(event);
  }

  onEsc() {
    if (this.closeEsc) {
      this.close();
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/modal/default/script.ts